
const pic=[
    {
        id:1,
        title:'Youth Justice center VR application',
        converImg: require("../components/Card/center.jpg"),
        url:"/vr"
    },

]
export default pic;